exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1-ifQJoeuKpUD1ejl59HAe{background:url(" + require("../img/Background/plain.png") + ") 50% no-repeat #84db9e;background-size:contain;position:relative;height:100%;width:100%}._2gfegcvaqMSvro6dkd5TMq{position:absolute;top:15%;width:100%;text-shadow:3px 3px 3px rgba(0,0,0,.6);text-align:center}._2sfwZTC7lXiH9cgIKzmolZ{width:50%;position:absolute;top:25%;left:25%;background:#fff;border:2px solid #ccc;border-radius:10px;height:60%;overflow-y:auto;padding-right:26px}._1BeZeUu_1-eYHFiBZQ-co7{font-weight:700}._38rYP_VBopO9HG80ZUDJKK{margin-bottom:5px;margin-top:0}._291gchILpPiA7IskCIJBlB{color:#080}._35zUJMbf4QNv0JZTXeGG8B{color:#c00}._2PePjWQjfll3R-u1Zuz5rO{position:absolute;bottom:5%;left:45%}@media (orientation:portrait){._2sfwZTC7lXiH9cgIKzmolZ{width:70%;left:15%}}@media (max-width:767px){._2sfwZTC7lXiH9cgIKzmolZ{font-size:.5em}}", ""]);

// exports
exports.locals = {
	"review-screen": "_1-ifQJoeuKpUD1ejl59HAe",
	"reviewScreen": "_1-ifQJoeuKpUD1ejl59HAe",
	"title": "_2gfegcvaqMSvro6dkd5TMq",
	"title": "_2gfegcvaqMSvro6dkd5TMq",
	"answer-summary": "_2sfwZTC7lXiH9cgIKzmolZ",
	"answerSummary": "_2sfwZTC7lXiH9cgIKzmolZ",
	"question-text": "_1BeZeUu_1-eYHFiBZQ-co7",
	"questionText": "_1BeZeUu_1-eYHFiBZQ-co7",
	"answer-text": "_38rYP_VBopO9HG80ZUDJKK",
	"answerText": "_38rYP_VBopO9HG80ZUDJKK",
	"submitted-correct": "_291gchILpPiA7IskCIJBlB _38rYP_VBopO9HG80ZUDJKK",
	"submittedCorrect": "_291gchILpPiA7IskCIJBlB _38rYP_VBopO9HG80ZUDJKK",
	"submitted-wrong": "_35zUJMbf4QNv0JZTXeGG8B _38rYP_VBopO9HG80ZUDJKK",
	"submittedWrong": "_35zUJMbf4QNv0JZTXeGG8B _38rYP_VBopO9HG80ZUDJKK",
	"next-btn": "_2PePjWQjfll3R-u1Zuz5rO",
	"nextBtn": "_2PePjWQjfll3R-u1Zuz5rO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&camelCase!./~/postcss-loader!./src/styles/Review.css
// module id = 481
// module chunks = 0